// extracted by mini-css-extract-plugin
module.exports = {"primary":"#b42e46","bgPrimary":"\"#303c5a\"","muted":"#6c757d"};